import { apiClientV2 } from '../../apiClient';
import { getBrowserTz } from '@/helpers/tzDate'

const baseURL = process.env.VUE_APP_API_FINANCIAL_RECORD_URL

export const expenseByActivity = async (params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/dashboard/expense_by_activity',
    params,
  })

  return response?.data
}

export const expenseByPeriod = async (params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/dashboard/expense_by_period',
    params,
    headers: {
      "X-Timezone-Offset": getBrowserTz().tz
    }
  })

  return response?.data
}
